import { Redirect, Switch } from 'react-router-dom';

import PropTypes from 'prop-types';

import { useTransl } from 'shared/lib/i18n';

import BuildingPopUpsContainer from './BuildingPopUpsContainer';
import RemoteDoormanAgentsListContainer from './RemoteDoormanAgentsListContainer';
import RemoteDoormanAgentsLogContainer from './RemoteDoormanAgentsLogContainer';
import RemoteDoormanAgentsManagementContainer from './RemoteDoormanAgentsManagementContainer';
import RemoteDoormanCallsListContainer from './RemoteDoormanCallsListContainer';

import Route from '../../routes/SentryRoute';
import TabsComponentWithLinks from '../Tabs/TabsComponentWithLinks';

const RemoteDoormanRouter = (props) => {
  const { match, location } = props;

  const { t } = useTransl();

  const tabData = [
    {
      label: t('remoteDoorman.callsLog'),
      url: `${match.url}/calls`,
    },
    {
      label: t('remoteDoorman.agentsLog'),
      url: `${match.url}/agents-log`,
    },
    {
      label: t('remoteDoorman.agentsList'),
      url: `${match.url}/agents-list`,
    },
    {
      label: t('remoteDoorman.agentManagement'),
      url: `${match.url}/agents-management`,
    },
    {
      label: t('remoteDoorman.buildingPopUps'),
      url: `${match.url}/pop-ups`,
    },
  ];

  return (
    <>
      <TabsComponentWithLinks
        tabData={tabData}
        currentUrl={location.pathname}
      />
      <Switch>
        <Route
          exact
          path={`${match.url}`}
          render={() => <Redirect to={`${match.url}/calls`} />}
        />
        <Route
          exact
          path={`${match.url}/calls`}
          component={RemoteDoormanCallsListContainer}
        />
        <Route
          exact
          path={`${match.path}/agents-log`}
          component={RemoteDoormanAgentsLogContainer}
        />
        <Route
          exact
          path={`${match.path}/agents-list`}
          component={RemoteDoormanAgentsListContainer}
        />
        <Route
          exact
          path={`${match.path}/agents-management`}
          component={RemoteDoormanAgentsManagementContainer}
        />
        <Route
          exact
          path={`${match.path}/pop-ups`}
          component={BuildingPopUpsContainer}
        />
      </Switch>
    </>
  );
};

RemoteDoormanRouter.propTypes = {
  match: PropTypes.instanceOf(Object).isRequired,
  location: PropTypes.instanceOf(Object).isRequired,
};

export default RemoteDoormanRouter;
